//horizontal slider
document.querySelectorAll(".horizontal-slider").forEach((slider) => {

    const slides = Array.from(slider.querySelectorAll(":scope > div"));

    function updateSlides() {
        const sliderRect = slider.getBoundingClientRect();
        const sliderCenter = sliderRect.left + sliderRect.width / 2;

        const centralWidth = sliderRect.width * 0.70;
        const centralLeft = sliderCenter - centralWidth / 2;
        const centralRight = sliderCenter + centralWidth / 2;

        slides.forEach((slide) => {
            const rect = slide.getBoundingClientRect();
            const slideCenter = rect.left + rect.width / 2;

            const isCentral =
                slideCenter >= centralLeft &&
                slideCenter <= centralRight;

            slide.classList.toggle("is-central", isCentral);
        });
    }

    slider.addEventListener("scroll", updateSlides);
    window.addEventListener("resize", updateSlides);
    updateSlides();

    slider.addEventListener(
		'wheel',
		(event) => {
			event.preventDefault();

			targetScrollLeft += event.deltaY * 2;

			const maxScrollLeft = slider.scrollWidth - slider.clientWidth;

			targetScrollLeft = Math.max(0, Math.min(targetScrollLeft, maxScrollLeft));

			if (!animationFrame) {
				animationFrame = requestAnimationFrame(smoothScroll);
			}
		},
		{ passive: false }
	);


    let isDragging = false;
	let startX = 0;
	let startTargetScrollLeft = 0;

	let targetScrollLeft = slider.scrollLeft;
	let animationFrame = null;

	function clampScroll(value) {
		const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
		return Math.max(0, Math.min(value, maxScrollLeft));
	}

	function smoothScroll() {
		const currentScrollLeft = slider.scrollLeft;
		const distance = targetScrollLeft - currentScrollLeft;

		slider.scrollLeft = currentScrollLeft + distance * 0.12;

		if (Math.abs(distance) > 0.5) {
			animationFrame = requestAnimationFrame(smoothScroll);
		} else {
			slider.scrollLeft = targetScrollLeft;
			animationFrame = null;
		}
	}

	function startSmoothScroll() {
		if (!animationFrame) {
			animationFrame = requestAnimationFrame(smoothScroll);
		}
	}

	slider.addEventListener('pointerdown', (event) => {
		isDragging = true;

		startX = event.clientX;
		startTargetScrollLeft = targetScrollLeft;

		slider.classList.add('is-dragging');
		slider.setPointerCapture(event.pointerId);

		event.preventDefault();
	});

	slider.addEventListener('pointermove', (event) => {
		if (!isDragging) return;

		const distance = event.clientX - startX;

		targetScrollLeft = clampScroll(startTargetScrollLeft - distance);

		startSmoothScroll();

		event.preventDefault();
	});

	slider.addEventListener('pointerup', (event) => {
		isDragging = false;
		slider.classList.remove('is-dragging');

		if (slider.hasPointerCapture(event.pointerId)) {
			slider.releasePointerCapture(event.pointerId);
		}
	});

	slider.addEventListener('pointercancel', (event) => {
		isDragging = false;
		slider.classList.remove('is-dragging');

		if (slider.hasPointerCapture(event.pointerId)) {
			slider.releasePointerCapture(event.pointerId);
		}
	});

	slider.addEventListener(
        'wheel',
        (event) => {
            const horizontalScrollSpeed = 0.5;
            const verticalScrollSpeed = 0.5;

            const wheelAmount = event.deltaY !== 0 ? event.deltaY : event.deltaX;
            const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
            const tolerance = 2;

            const atStart = targetScrollLeft <= tolerance;
            const atEnd = targetScrollLeft >= maxScrollLeft - tolerance;

            const wantsToScrollLeft = wheelAmount < 0;
            const wantsToScrollRight = wheelAmount > 0;

            const shouldAllowPageScroll =
                (wantsToScrollLeft && atStart) ||
                (wantsToScrollRight && atEnd);

            if (shouldAllowPageScroll) {
                event.preventDefault();

                window.scrollBy({
                    top: event.deltaY * verticalScrollSpeed,
                    left: 0,
                    behavior: 'auto',
                });

                return;
            }

            event.preventDefault();

            targetScrollLeft = clampScroll(
                targetScrollLeft + wheelAmount * horizontalScrollSpeed
            );

            startSmoothScroll();
        },
        { passive: false }
    );

});